import React from "react";
import InputBox from "../commonComponents/inputComponents/InputBox";

import "./licensePlate.css";

const MotorLicense = React.forwardRef((_, ref) => {
  const { idTopThreeDigitsRef, idBottomFiveDigitsRef } = ref;

  return (
    <div className="license-container motor-license-container">
      <span className="license-title">شماره پلاک</span>
      <span className="license-country">ایران</span>
      <div className="motor-license">
        <InputBox
          gap="0"
          width="60%"
          persianNum={true}
          placeHolder="123"
          center={true}
          maxChar={3}
          ref={idTopThreeDigitsRef}
        />
        <InputBox
          gap="10px"
          width="80%"
          persianNum={true}
          placeHolder="12345"
          center={true}
          maxChar={5}
          ref={idBottomFiveDigitsRef}
        />
      </div>
    </div>
  );
});

export default MotorLicense;
